module.exports = __webpack_public_path__ + "img/16.e9dc5b15.jpg";